export default __webpack_public_path__ + "static/media/profile.b5d14c24.png";